import {
  FunctionFieldType,
  FunctionItem,
  FunctionItemDefaultValue,
  FunctionTableColumnValue,
  FunctionValue,
} from '@makyoapp/makyo-common'

import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

import { FnFieldSingle } from './FnFieldSingle'

interface FnFieldsProps {
  item: FunctionItem
  value?: FunctionValue
  onChange: (next: FunctionValue) => void
}

export function FnFields({ item, onChange, value }: FnFieldsProps) {
  const { table, tableList } = useGridV2Context()

  return (
    <>
      {item.fields.map((field) => {
        let theValue
        if (value && typeof value.value === 'object') {
          theValue = value.value[field.id]
        }

        let shouldShow = !field.skip
        if (field.showWhen) {
          shouldShow = field.showWhen(value?.value, table!)
        }

        if (!shouldShow) {
          return null
        }

        return (
          <FnFieldSingle
            item={item}
            field={field}
            key={`${item.id}-${field.id}`}
            value={theValue}
            allValue={value}
            onChange={(v) => {
              const sameType = value ? value.item.id === item.id : false

              const updateDependValue = (
                ty: FunctionFieldType,
                dependId: string,
                values: Record<string, FunctionItemDefaultValue>,
                table: string
              ) => {
                const tb = tableList.find((t) => table === t.id)
                switch (ty) {
                  case FunctionFieldType.Title:
                  case FunctionFieldType.Hr:
                  case FunctionFieldType.Ifs:
                  case FunctionFieldType.If:
                  case FunctionFieldType.IfsThen:
                    break
                  case FunctionFieldType.ColumnOrCustom:
                    values[dependId] = {
                      isCustom: false,
                      value: tb?.columns[0]?.id || '',
                    }
                    break
                  case FunctionFieldType.ColumnOrCustomMulti:
                  case FunctionFieldType.ColumnOrCustomWithTable:
                    break
                  case FunctionFieldType.Select:
                  case FunctionFieldType.Input:
                  case FunctionFieldType.Switch:
                  case FunctionFieldType.Direction:
                    break
                }
              }

              let payload: FunctionValue = {
                item: {
                  id: item.id,
                  fn: item.fn,
                  title: item.title,
                },
                value: {},
                returnType: item.returnType,
              }

              if (sameType && value) {
                const copy = { ...value.value }
                copy[field.id] = v

                if (field.type === FunctionFieldType.ColumnOrCustomWithTable && field.valueDependBy) {
                  const sibling = item.fields.find((f) => f.id === field.valueDependBy)
                  if (sibling) {
                    const vv = v as FunctionTableColumnValue
                    updateDependValue(sibling.type, sibling.id, copy, vv?.table || '')
                  }
                }

                payload.value = copy
                //
              } else {
                const nextValues = {
                  [field.id]: v,
                }
                if (field.type === FunctionFieldType.ColumnOrCustomWithTable && field.valueDependBy) {
                  const sibling = item.fields.find((f) => f.id === field.valueDependBy)
                  if (sibling) {
                    const vv = v as FunctionTableColumnValue
                    updateDependValue(sibling.type, sibling.id, nextValues, vv?.table || '')
                  }
                }

                payload.value = nextValues
              }

              // !Disabled Since Timezone configuration is moved to global table settings
              // const hasDateOperator =
              //   !!(payload.value?.criteria as any)?.conditions?.find((c: any) => c.operator.includes('date')) ||
              //   !!(payload.value?.conditions as any)?.conditions?.find((c: any) => c.operator.includes('date')) ||
              //   !!(payload.value?.logical_expression as any)?.condition?.operator?.includes('date')

              // if (hasDateOperator) {
              //   payload.options = {
              //     dtTimezone: value?.options?.dtTimezone || TZ_AUTO.value,
              //   }
              // } else {
              //   payload.options = undefined
              // }

              onChange(payload)
            }}
          />
        )
      })}
    </>
  )
}
